import { render, staticRenderFns } from "./entities.vue?vue&type=template&id=b58b7264&scoped=true"
import script from "./entities.vue?vue&type=script&lang=js"
export * from "./entities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b58b7264",
  null
  
)

export default component.exports